





























































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiIbs } from "@/store/modules/SupervisiIbsStore";
import SupervisiIbsSvc from "@/services/SupervisiIbsService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";
import {
  SupervisiIbsKategori,
  KATEGORI_LABEL,
  KATEGORI_ORDER,
  JENIS_SUPERVISI_OPTS,
  VENTILASI_OPTS,
  JABATAN_SUPERVISOR_OPTS,
  KATEGORI_KEPATUHAN_LABEL,
  kategoriKepatuhanColor,
} from "@/types/SupervisiIbs";

const JAM_CARRIER = toDateString(new Date()) || "2000-01-01";

@Component({ components: { CardModalTtd, VCDateTimePicker } })
export default class SupervisiIbsFormPage extends Vue {
  parent: any = {
    nomor_formulir: "",
    tanggal_supervisi: localISODate(),
    waktu_mulai: "",
    waktu_selesai: "",
    jenis_supervisi: "rutin",
    unit_nama: "Instalasi Bedah Sentral (IBS)",
    sub_lokasi: "",
    supervisor_jabatan: "IPCN",
    kepala_unit_nama_manual: "",
    ketua_ppi_nama_manual: "",
    temuan_utama: "",
    rencana_tindak_lanjut: "",
    rekomendasi_direktur: "",
  };
  itemsDraft: any[] = [];
  observasiDraft: any[] = [];
  saving = false;
  showTtdModal = false;
  signRole: "supervisor" | "kepala-unit" | "ketua-ppi" = "supervisor";

  kategoriOrder: SupervisiIbsKategori[] = KATEGORI_ORDER;
  kategoriLabel = KATEGORI_LABEL;
  jenisOpts = JENIS_SUPERVISI_OPTS;
  ventilasiOpts = VENTILASI_OPTS;
  jabatanOpts = JABATAN_SUPERVISOR_OPTS;
  monitorOpts = [
    { text: "Ya", value: true },
    { text: "Tidak", value: false },
  ];

  get routeId() {
    return this.$route.params.id;
  }

  get isNew() {
    return this.routeId === "baru";
  }

  get current() {
    return storeSupervisiIbs.currentItem;
  }

  get locked() {
    return !!(this.current && this.current.is_locked);
  }

  get supervisorName() {
    if (this.current && this.current.supervisor) return this.current.supervisor.nama || "";
    return userModule.user?.nama || "";
  }

  kepatuhanColor(kat: string | null) {
    return kategoriKepatuhanColor(kat);
  }

  kepatuhanLabel(kat: string | null) {
    return kat ? KATEGORI_KEPATUHAN_LABEL[kat] || kat : "";
  }

  /** Skor per section dihitung dari draft (live). */
  sectionScore(kategori: SupervisiIbsKategori) {
    let ya = 0;
    let tidak = 0;
    for (const it of this.itemsDraft) {
      if (it.kategori !== kategori) continue;
      if (it.hasil === "ya") ya++;
      else if (it.hasil === "tidak") tidak++;
    }
    const dinilai = ya + tidak;
    const skor = dinilai > 0 ? Math.round((ya / dinilai) * 1000) / 10 : null;
    return { ya, tidak, dinilai, skor, kategori: this.katFromScore(skor) };
  }

  get liveTotal() {
    let ya = 0;
    let tidak = 0;
    for (const it of this.itemsDraft) {
      if (it.hasil === "ya") ya++;
      else if (it.hasil === "tidak") tidak++;
    }
    const dinilai = ya + tidak;
    const skor = dinilai > 0 ? Math.round((ya / dinilai) * 1000) / 10 : null;
    return { ya, tidak, dinilai, skor, kategori: this.katFromScore(skor) };
  }

  katFromScore(skor: number | null): string | null {
    if (skor === null) return null;
    if (skor >= 90) return "sangat_baik";
    if (skor >= 80) return "baik";
    if (skor >= 70) return "cukup";
    return "perlu_perbaikan";
  }

  warnCls(val: number | null, lo: number, hi: number) {
    if (val === null || val === undefined || val === ("" as any)) return "";
    return val < lo || val > hi ? "out-of-range" : "";
  }

  async mounted() {
    if (!this.isNew) await this.load();
  }

  @Watch("$route.params.id")
  async onRouteIdChange(newId: string) {
    if (newId && newId !== "baru") await this.load();
  }

  async load() {
    await storeSupervisiIbs.refresh(Number(this.routeId));
    if (this.current) {
      this.parent = {
        nomor_formulir: this.current.nomor_formulir,
        tanggal_supervisi: this.current.tanggal_supervisi,
        waktu_mulai: this.trimTime(this.current.waktu_mulai) || "",
        waktu_selesai: this.trimTime(this.current.waktu_selesai) || "",
        jenis_supervisi: this.current.jenis_supervisi || "rutin",
        unit_nama: this.current.unit_nama || "",
        sub_lokasi: this.current.sub_lokasi || "",
        supervisor_jabatan: this.current.supervisor_jabatan || "",
        kepala_unit_nama_manual: this.current.kepala_unit_nama_manual || "",
        ketua_ppi_nama_manual: this.current.ketua_ppi_nama_manual || "",
        temuan_utama: this.current.temuan_utama || "",
        rencana_tindak_lanjut: this.current.rencana_tindak_lanjut || "",
        rekomendasi_direktur: this.current.rekomendasi_direktur || "",
      };
      this.itemsDraft = (this.current.items || []).map(i => ({ ...i }));
      this.observasiDraft = (this.current.observasi || []).map(o => ({ ...o }));
    }
  }

  get tanggalSupervisiDate(): Date | null {
    return composeDate(this.parent.tanggal_supervisi);
  }
  set tanggalSupervisiDate(val: Date | null) {
    this.parent.tanggal_supervisi = toDateString(val) || "";
  }

  get waktuMulaiDate(): Date | null {
    if (!this.parent.waktu_mulai) return null;
    return composeDate(JAM_CARRIER, this.trimTime(this.parent.waktu_mulai));
  }
  set waktuMulaiDate(val: Date | null) {
    this.parent.waktu_mulai = toTimeString(val);
  }

  get waktuSelesaiDate(): Date | null {
    if (!this.parent.waktu_selesai) return null;
    return composeDate(JAM_CARRIER, this.trimTime(this.parent.waktu_selesai));
  }
  set waktuSelesaiDate(val: Date | null) {
    this.parent.waktu_selesai = toTimeString(val);
  }

  dateCache = new Map<string, Date>();

  dateFromString(val: unknown): Date | null {
    const tgl = typeof val === "string" ? val.slice(0, 10) : "";
    if (!tgl) return null;
    const cached = this.dateCache.get(tgl);
    if (cached) return cached;
    const d = composeDate(tgl);
    if (!d) return null;
    this.dateCache.set(tgl, d);
    return d;
  }

  setTanggal(obj: Record<string, unknown>, key: string, val: Date | null) {
    this.$set(obj, key, toDateString(val));
  }

  trimTime(v: string | null | undefined): string | null {
    if (!v) return null;
    const s = String(v).trim();
    return s.length >= 5 ? s.substring(0, 5) : null;
  }

  itemsByKategori(kategori: SupervisiIbsKategori) {
    return this.itemsDraft
      .filter(i => i.kategori === kategori)
      .sort((a, b) => a.urutan - b.urutan);
  }

  addObservasi() {
    this.observasiDraft.push({
      label_ruang: "",
      suhu_c: null,
      kelembaban_rh: null,
      tekanan_pa: null,
      ach: null,
      jenis_ventilasi: null,
      hepa_ganti_terakhir: null,
      monitoring_terdokumentasi: null,
      catatan: null,
    });
  }

  removeObservasi(idx: number) {
    this.observasiDraft.splice(idx, 1);
  }

  async saveNew() {
    this.saving = true;
    try {
      const payload: any = {
        tanggal_supervisi: this.parent.tanggal_supervisi,
        waktu_mulai: this.trimTime(this.parent.waktu_mulai),
        waktu_selesai: this.trimTime(this.parent.waktu_selesai),
        jenis_supervisi: this.parent.jenis_supervisi || "rutin",
        unit_nama: this.parent.unit_nama || null,
        sub_lokasi: this.parent.sub_lokasi || null,
        supervisor_user_id: userModule.user.id,
        supervisor_jabatan: this.parent.supervisor_jabatan || null,
        kepala_unit_nama_manual: this.parent.kepala_unit_nama_manual || null,
        ketua_ppi_nama_manual: this.parent.ketua_ppi_nama_manual || null,
      };
      const resp = await SupervisiIbsSvc.create(payload);
      const id = resp.data.data.id;
      this.$router.replace({ name: "supervisi-ibs-form", params: { id: String(id) } });
    } finally {
      this.saving = false;
    }
  }

  async saveDraft() {
    if (!this.current) return;
    this.saving = true;
    try {
      await SupervisiIbsSvc.update(this.current.id, {
        tanggal_supervisi: this.parent.tanggal_supervisi,
        waktu_mulai: this.trimTime(this.parent.waktu_mulai),
        waktu_selesai: this.trimTime(this.parent.waktu_selesai),
        jenis_supervisi: this.parent.jenis_supervisi || "rutin",
        unit_nama: this.parent.unit_nama || null,
        sub_lokasi: this.parent.sub_lokasi || null,
        supervisor_jabatan: this.parent.supervisor_jabatan || null,
        kepala_unit_nama_manual: this.parent.kepala_unit_nama_manual || null,
        ketua_ppi_nama_manual: this.parent.ketua_ppi_nama_manual || null,
        temuan_utama: this.parent.temuan_utama || null,
        rencana_tindak_lanjut: this.parent.rencana_tindak_lanjut || null,
        rekomendasi_direktur: this.parent.rekomendasi_direktur || null,
      });
      await SupervisiIbsSvc.updateItems(
        this.current.id,
        this.itemsDraft.map(i => ({
          id: i.id,
          hasil: i.hasil || null,
          masalah: i.masalah || null,
          rekomendasi: i.rekomendasi || null,
        }))
      );
      await SupervisiIbsSvc.updateObservasi(
        this.current.id,
        this.observasiDraft.map(o => ({
          label_ruang: o.label_ruang || "",
          suhu_c: this.numOrNull(o.suhu_c),
          kelembaban_rh: this.numOrNull(o.kelembaban_rh),
          tekanan_pa: this.numOrNull(o.tekanan_pa),
          ach: this.numOrNull(o.ach),
          jenis_ventilasi: o.jenis_ventilasi || null,
          hepa_ganti_terakhir: o.hepa_ganti_terakhir || null,
          monitoring_terdokumentasi:
            o.monitoring_terdokumentasi === null || o.monitoring_terdokumentasi === undefined
              ? null
              : o.monitoring_terdokumentasi,
          catatan: o.catatan || null,
        }))
      );
      await this.load();
    } finally {
      this.saving = false;
    }
  }

  numOrNull(v: any): number | null {
    if (v === null || v === undefined || v === "") return null;
    const n = Number(v);
    return isNaN(n) ? null : n;
  }

  openSign(role: "supervisor" | "kepala-unit" | "ketua-ppi") {
    this.signRole = role;
    this.showTtdModal = true;
  }

  async onSignPassword(password: string) {
    if (!this.current) return;
    this.saving = true;
    try {
      if (!this.locked) await this.saveDraft();
      if (this.signRole === "supervisor") {
        await SupervisiIbsSvc.signSupervisor(this.current.id, { password });
      } else if (this.signRole === "kepala-unit") {
        if (!this.current.kepala_unit_user_id) {
          await SupervisiIbsSvc.update(this.current.id, { kepala_unit_user_id: userModule.user.id });
        }
        await SupervisiIbsSvc.signKepalaUnit(this.current.id, { password });
      } else {
        if (!this.current.ketua_ppi_user_id) {
          await SupervisiIbsSvc.update(this.current.id, { ketua_ppi_user_id: userModule.user.id });
        }
        await SupervisiIbsSvc.signKetuaPpi(this.current.id, { password });
      }
      appModule.addMsgTtd("");
      await this.load();
    } catch (e) {
      const msg = (e as any)?.response?.data?.message || "Gagal menandatangani";
      appModule.addMsgTtd(msg);
      this.showTtdModal = true;
    } finally {
      this.saving = false;
    }
  }

  printPdf() {
    if (this.current) SupervisiIbsSvc.printPdf(this.current.id);
  }

  back() {
    this.$router.push({ name: "supervisi-ibs-list" });
  }

  formatDt(dt?: string | null) {
    if (!dt) return "";
    const d = new Date(dt);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}
